import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadDateStatusFailed, loadDateStatusSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadDateStatus(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/time-settings/status`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadDateStatusSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadDateStatusFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadDateStatusFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
